import m from "./../../../dist/es2015/locales/nb_NO.js";
export const am5locales_nb_NO = m;